import { withSuspense } from '@/ui/utils/withSuspense'

import { useLendWithdrawDialog } from './logic/useLendWithdrawDialog'
import { WithdrawView } from './views/LendWithdrawView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { SuccessView } from '@/features/dialogs/common/views/SuccessView'
import { MyWalletProps } from '@/features/isolated-details/components/my-wallet/MyWallet'

type LendWithdrawDialogContentContainerProps = { closeDialog: () => void } & { walletOverview: MyWalletProps }

function LendWithdrawDialogContentContainer({ closeDialog, walletOverview }: LendWithdrawDialogContentContainerProps) {
  const {
    objectives,
    actionsContext,
    withdrawOptions,
    assetsToWithdrawFields,
    pageStatus,
    form,
    withdrawAsset,
    currentPositionOverview,
    updatedPositionOverview,
  } = useLendWithdrawDialog({ walletOverview })

  if (pageStatus.state === 'success') {
    return (
      <SuccessView
        objectiveType="isolatedWithdraw"
        tokenWithValue={withdrawAsset}
        onProceed={closeDialog}
        proceedText="View in dashboard"
      />
    )
  }

  return (
    <WithdrawView
      walletOverview={walletOverview}
      withdrawOptions={withdrawOptions}
      objectives={objectives}
      actionsContext={actionsContext}
      form={form}
      assetsToWithdrawFields={assetsToWithdrawFields}
      pageStatus={pageStatus}
      withdrawAsset={withdrawAsset}
      currentPositionOverview={currentPositionOverview}
      updatedPositionOverview={updatedPositionOverview}
    />
  )
}

const LendWithdrawDialogContentContainerWithSuspense = withSuspense(
  LendWithdrawDialogContentContainer,
  DialogContentSkeleton,
)
export { LendWithdrawDialogContentContainerWithSuspense as LendWithdrawDialogContentContainer }
